"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = Menu;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _RecursiveMenu = require("../RecursiveMenu");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function Menu(_ref) {
  var activeLanguage = _ref.activeLanguage,
    catalog = _ref.catalog,
    brands = _ref.brands,
    isLoggedIn = _ref.isLoggedIn,
    languages = _ref.languages,
    links = _ref.links,
    onLanguageChange = _ref.onLanguageChange,
    onLinkClick = _ref.onLinkClick,
    onLogout = _ref.onLogout,
    onModalClose = _ref.onModalClose,
    openNextLevel = _ref.openNextLevel,
    text = _ref.text,
    className = _ref.className;
  var handleLanguageChange = function handleLanguageChange(language) {
    return function (e) {
      e.preventDefault();
      onLanguageChange(language);
      onModalClose(e);
    };
  };
  var handleLogoutClick = function handleLogoutClick(e) {
    e.preventDefault();
    onLogout();
    onModalClose(e);
  };
  var areProductsSpecified = (0, _react.useCallback)(function (products) {
    return !!products && Array.isArray(products) && products.length > 0;
  }, []);
  var renderLink = (0, _react.useCallback)(function (link) {
    var _link$children;
    if ((_link$children = link.children) !== null && _link$children !== void 0 && _link$children.length) {
      return /*#__PURE__*/_react["default"].createElement("a", {
        className: "cds-ModalMenu-Link cds-ModalMenu-Link--Arrow",
        href: "#",
        onClick: openNextLevel(text.home, link.children, undefined, link.title)
      }, link.title, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
        className: "cds-ModalMenu-ArrowIcon",
        name: _Icon.ICON_NAME.arrowRight
      }));
    }
    return /*#__PURE__*/_react["default"].createElement("a", {
      className: "cds-ModalMenu-Link",
      href: link.href,
      onClick: onLinkClick(link.href)
    }, link.title);
  }, [onLinkClick, openNextLevel, text.home]);
  var renderLinksGroup = (0, _react.useCallback)(function (linksGroup) {
    if (Array.isArray(linksGroup)) {
      return linksGroup.map(function (link) {
        return /*#__PURE__*/_react["default"].createElement("li", {
          className: "cds-ModalMenu-Item",
          key: link.title
        }, renderLink(link));
      });
    }
  }, [renderLink]);
  var renderLinksGroups = (0, _react.useCallback)(function (linksGroups) {
    if (Array.isArray(linksGroups)) {
      return linksGroups.map(function (linkGroup, index) {
        return /*#__PURE__*/_react["default"].createElement("ul", {
          className: "cds-ModalMenu cds-List--Border",
          key: index
        }, renderLinksGroup(linkGroup));
      });
    }
  }, [renderLinksGroup]);
  var rootClassName = (0, _classnames["default"])('cds-ModalMenu-Wrapper', className);
  return /*#__PURE__*/_react["default"].createElement("nav", {
    className: rootClassName
  }, /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-ModalMenu-Main"
  }, areProductsSpecified(catalog) && /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-ModalMenu-Item--Main"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "cds-ModalMenu-Link--Main cds-ModalMenu-Link--Arrow",
    href: "#",
    onClick: openNextLevel(text.home, catalog, undefined, text.catalog, _RecursiveMenu.MENU_CATEGORY_ID.catalog)
  }, text.catalog, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  }))), areProductsSpecified(brands) && /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-ModalMenu-Item--Main"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "cds-ModalMenu-Link--Main cds-ModalMenu-Link--Arrow",
    href: "#",
    onClick: openNextLevel(text.home, brands, undefined, text.brands, _RecursiveMenu.MENU_CATEGORY_ID.brands)
  }, text.brands, /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    className: "cds-ModalMenu-ArrowIcon",
    name: _Icon.ICON_NAME.arrowRight
  })))), renderLinksGroups(links), /*#__PURE__*/_react["default"].createElement("ul", {
    className: "cds-ModalMenu"
  }, languages && languages.map(function (language) {
    if (activeLanguage === language.code) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement("li", {
      className: "cds-ModalMenu-Item",
      key: language.code
    }, /*#__PURE__*/_react["default"].createElement("a", {
      className: "cds-ModalMenu-Link",
      href: "#",
      onClick: handleLanguageChange(language.code)
    }, language.label));
  }), isLoggedIn && /*#__PURE__*/_react["default"].createElement("li", {
    className: "cds-ModalMenu-Item"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "cds-ButtonLink cds-ModalMenu-Link",
    onClick: handleLogoutClick
  }, text.logout))));
}